import { forwardRef } from "react";
import { IconCoin } from "@tabler/icons-react";
import { mapTopUpPacks } from "./mapTopupPacks";
import styles from "../subscriptionPayment.module.css";
import PriceCard from "./PriceCard";

const TopUpPacksSection = forwardRef(function TopUpPacksSection(
  { onCta, topUpPlans, currency },
  ref,
) {
  const topUpPacks = mapTopUpPacks(topUpPlans, { currency });
  return (
    <div className={styles.card} ref={ref}>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLeft}>
          <div
            className={styles.cardIcon}
            style={{ background: "#ecfdf5", color: "#10b981" }}
          >
            <IconCoin size={18} />
          </div>
          <div>
            <div className={styles.cardTitle}>Top-Up Credit Packs</div>
            <div className={styles.cardSubtitle}>
              One-time top-ups, no commitment — credits added instantly and
              never lost
            </div>
          </div>
        </div>
      </div>

      <div className={`${styles.cardBody} ${styles.cardBodyTopPad24}`}>
        <div className={styles.pricingGrid}>
          {topUpPacks?.map((pack) => (
            <PriceCard
              key={pack?.id}
              {...pack}
              onCtaClick={() => onCta(pack)}
            />
          ))}
        </div>

        <div className={styles.planTermsNote}>
          Top-ups add credits instantly and are never lost. They extend your
          validity by 1 month only when less than a month remains on your plan —
          otherwise they simply add credits.
        </div>
      </div>
    </div>
  );
});

export default TopUpPacksSection;
